import { Button, Fab, withWidth } from "@material-ui/core";
import { WithWidth } from "@material-ui/core/withWidth";
import AddIcon from "@material-ui/icons/Add";
import React from "react";

type AddAlertProps = {
  onAddAlert: () => void;
};

const AddAlertMobileButton = (props: AddAlertProps) => (
  <Fab
    style={{
      bottom: "30px",
      position: "fixed",
      right: "20px",
      zIndex: 9999,
    }}
    color="primary"
    onClick={props.onAddAlert}
  >
    <AddIcon />
  </Fab>
);

const AddAlertDesktopButton = (props: AddAlertProps) => (
  <div className="alerts-administration__add-alert-button">
    <Button onClick={props.onAddAlert} color="primary" variant="contained">
      Add Alert
    </Button>
  </div>
);

const AddAlertButton = (props: AddAlertProps & WithWidth) =>
  ["xs", "sm", "md"].includes(props.width) ? (
    <AddAlertMobileButton {...props} />
  ) : (
    <AddAlertDesktopButton {...props} />
  );

export default withWidth()(AddAlertButton);
